import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__components_Form_Label_Label_js_6fcf26a3__ from "../../components/Form/Label/Label.js";
import * as __WEBPACK_EXTERNAL_MODULE__Field_FieldContext_js_2aa6688b__ from "../Field/FieldContext.js";
function Label({ children }) {
    const { name } = (0, __WEBPACK_EXTERNAL_MODULE__Field_FieldContext_js_2aa6688b__.useFieldContext)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Form_Label_Label_js_6fcf26a3__["default"], {
        name: name,
        children: children
    });
}
const Label_rslib_entry_ = Label;
export { Label_rslib_entry_ as default };

//# sourceMappingURL=Label.js.map